import { put, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import analyticsActions from '../actions';

function setConfig() {
  window.gtag('config', window.GTAG_TRACKING_ID, {
    custom_map: {
      dimension1: 'app_request_id',
      dimension2: 'market',
      dimension3: 'product',
      dimension4: 'status',
      dimension5: 'app_ids',
    },
  });
}

function* gtagInit() {
  try {
    if (window.gtag) {
      yield setConfig();
      yield put(actions.initSuccess());
    } else {
      throw new Error('gtag is not available.');
    }
  } catch (e) {
    yield put(actions.initFailed(e));
  }
}

function* gtagSendScreenview({ payload }) {
  const { analytics, refs } = yield select();

  if (analytics.gtag) {
    try {
      window.gtag('set', 'screen_name', payload);
      window.gtag('event', 'screen_view', {
        app_ids: refs.appIds,
        app_name: 'OAO',
        app_request_id: refs.appRequestId,
        app_version: window.version,
        market: refs.market,
        product: refs.product,
        refs,
        screen_name: payload,
        status: refs.status,
      });

      yield put(actions.sendScreenviewSuccess(payload));
    } catch (e) {
      yield put(actions.sendScreenviewFailed(e));
    }
  }
}

function* gtagSendEvent({ payload, type }) {
  const { analytics, page, refs, ui } = yield select();
  const { activeGroup } = ui;

  if (analytics.gtag) {
    try {
      const { eventCategory, eventLabel } = payload;

      window.gtag('event', type.toLowerCase(), {
        app_ids: refs.appIds || '',
        app_name: 'OAO',
        app_request_id: refs.appRequestId || '',
        app_version: window.version || '',
        event_label: eventLabel || '',
        event_name: eventCategory || '',
        market: refs.market || '',
        oao_group_name: activeGroup || '',
        oao_page_name: page.name || '',
        product: refs.product || '',
        refs,
        status: refs.status || '',
      });

      yield put(actions.sendEventSuccess(type));
    } catch (e) {
      yield put(actions.sendEventFailed(e));
    }
  }
}

export default [
  takeEvery(analyticsActions.ANALYTICS_INIT, gtagInit),
  takeEvery(analyticsActions.ANALYTICS_SEND_SCREENVIEW, gtagSendScreenview),
  takeEvery(
    [
      analyticsActions.FIELD_BLUR,
      analyticsActions.FIELD_ERROR,
      analyticsActions.GOOGLE_PLACES_AUTOCOMPLETE,
      analyticsActions.GROUP,
      analyticsActions.GROUP_NAV,
      analyticsActions.GROUP_SUBMIT,
      analyticsActions.GROUP_SUBMIT_ERROR,
      analyticsActions.GROUP_SUBMIT_SUCCESS,
      analyticsActions.PAGE,
      analyticsActions.PAGE_NAV,
      analyticsActions.PAGE_SUBMIT,
      analyticsActions.PAGE_SUBMIT_ERROR,
      analyticsActions.PAGE_SUBMIT_SUCCESS,
      analyticsActions.SERVER_ERROR,
      analyticsActions.START,
      analyticsActions.TIMEOUT,
      analyticsActions.TIMEOUT_WARNING,
      analyticsActions.TOOLTIP_VIEW,
      analyticsActions.WORKFLOW_END,
    ],
    gtagSendEvent,
  ),
];
